define('optionsConfigDialogView',[
  'module',
  'underscore',
  'backbone',
  'app',
  'jquery',
  'settings',
  'template!optionsConfigDialogTpl',
  'dialogView',
  'optionMixEditCollectionView'
], function (
  module,
  _,
  Backbone,
  App,
  $,
  Settings,
  viewTpl,
  DialogView,
  OptionMixEditCollectionView
) {
  'use strict';

  var ConfigOptionsView = DialogView.extend({
    template: viewTpl,

    events: {
      'click .dropdown-menu-printzone a': 'onChangePrinZone',
      'click .dropdown-menu-option a': 'onChangeOption',
      'click .dropdownMenu-changeoption a': 'onChangeOption',
      'click .js-confirm': 'onConfigurationSelected',
      'change .input-quantity': 'onQuantityChange',
      'click .add-mix-line': 'onAddMixLineClick'
    },

    regions: {
      mixOptionRegion: '.mix-table-body'
    },

    serializeData: function () {
      var templateData = {};
      this.mixable = templateData.mixable = false;
      templateData.options = this.options.options;
      templateData.optionsMix = this.options.mixedOptions;
      templateData.availableOptions = this.options.availableOptions;
      if (this.options.product) {
        templateData.product = this.options.product.toJSON();
      }
      if (templateData.optionsMix && templateData.optionsMix.length > 0) {
        this.mixable = templateData.mixable = true;
      }
      if (this.options.selectedOptions && this.options.selectedOptions.length > 0) {
        var filteredSelectedOptions = [], that = this;
        templateData.availableOptions = this.options.availableOptions;

        // Sort each availableOption.productOptions alphabetically by name only if type is "color"
        _.each(templateData.availableOptions, function (availableOption) {
          if (availableOption.type === 'color' && availableOption.productOptions && availableOption.productOptions.length > 0) {
            availableOption.productOptions = _.sortBy(availableOption.productOptions, 'name');
          }
        });

        _.each(templateData.availableOptions, function (availableOption) {
          var selectedOne = _.findWhere(that.options.selectedOptions, {catId: availableOption.id});
          if (!selectedOne) {
            selectedOne = _.findWhere(that.options.selectedOptions, {catId: availableOption.code});
          }
          if (selectedOne) {
            _.each(availableOption.productOptions, function (productOption) {
              if (productOption.id === selectedOne.id) {
                availableOption.selected = productOption;
              }
            });
          }
        });

        _.each(this.options.selectedOptions, function (selectedOption) {
          var filteredSelectedOption = _.findWhere(templateData.availableOptions, {id: selectedOption.catId});
          if (filteredSelectedOption) {
            filteredSelectedOptions.push(filteredSelectedOption);
          }
        });
        templateData.options = filteredSelectedOptions;
      }
      return templateData;
    },

    onShow: function () {
      $.material.init();
      this.currentConfiguration = {
        quantity: 50,
        printZones: {},
        options: {}
      };

      if (this.mixable) {
        var collection = new Backbone.Collection(),
          that = this, pocs;
        this.productJson = this.options.product.toJSON();
        pocs = that.productJson.productOptionCategories;
        _.each(this.options.mixedOptions, function (mixedOption) {
          var sortedPocs = that.moveToTop(pocs, mixedOption.options);
          var defaultModel = new Backbone.Model({
            productOptionCategories: sortedPocs,
            quantity: mixedOption.quantity
          });
          collection.push(defaultModel);
        });

        this.optionMixEditCollectionView = new OptionMixEditCollectionView({
          collection: collection,
          product: this.productJson
        });
        this.getRegion('mixOptionRegion').show(this.optionMixEditCollectionView);
        this.optionMixEditCollectionView.on('delete', _.bind(this.deleteOptionMix, this));
      }
    },

    onAddMixLineClick: function () {
      var defaultModel = new Backbone.Model({
        productOptionCategories: this.productJson.productOptionCategories,
        quantity: 100
      });
      this.optionMixEditCollectionView.collection.push(defaultModel);
    },

    deleteOptionMix: function (view) {
      var selectedOptions = view.getMixConfiguration();
      var optionIds = selectedOptions.options;

      if(!optionIds)
        return;

      var modelToDelete = this.getSelectedOptions(optionIds);
      if (modelToDelete)
        this.optionMixEditCollectionView.collection.remove(modelToDelete);
    
     
    },

    getSelectedOptions: function (selectedOtionsIds) {
      var idsToCheck = [];
      _.each(selectedOtionsIds, function (optionId) {
        idsToCheck.push({
          optionId: optionId,
          found: false
        });
      }, this);

      _.each(this.optionMixEditCollectionView.collection.models, function (mixedOption) {    
        _.each(mixedOption.get('productOptionCategories'), function (category) {
            _.each(category.productOptions, function (categoryOption) {
              _.each(idsToCheck, function (idToCheck) {
                 if (categoryOption.id === idToCheck.optionId)
                    idToCheck.found = true;        
              }, this);  
            }, this);
        }, this); 

        var allOptionsChecked = _.every(idsToCheck, function (idToCheck) {
          return idToCheck.found;
        });
        
        if (allOptionsChecked)
          return mixedOption;
      }, this); 

      return null;
    },    

    onChangeOption: function (e) {
      e.preventDefault();
      var target = $(e.target),
        index = target.data('index'),
        optionId = target.data('optionId');
      this.$el.find('.option-' + index + '-label').text(target.text());
      this.currentConfiguration.options[index] = optionId;
    },

    onConfigurationSelected: function () {
      var optionsArray = [];
      if (this.currentConfiguration.options) {
        optionsArray = $.map(this.currentConfiguration.options, function (value) {
          return [value];
        });
      }
      if (optionsArray && optionsArray.length > 0) {
        this.trigger('options-changed', this.currentConfiguration);
      } else if (this.mixable) {
        this.currentConfiguration.optionsMix = this.optionMixEditCollectionView.getMixesConfiguration();
        this.currentConfiguration.quantity = 0;
        _.each(this.currentConfiguration.optionsMix, _.bind(function (mix) {
          this.currentConfiguration.quantity += mix.quantity;
        }, this));
        this.trigger('options-changed', this.currentConfiguration);
      }

    },

    moveToTop: function (pocs, options) {
      var newPocs = [];
      _.each(pocs, function (poc) {
        var opt = _.findWhere(options, {catId: poc.id});
        if (opt) {
          var optionIndex = opt.id;
          var poIndex = poc.productOptions.findIndex(function (po) {
            return po.id === optionIndex;
          });
          poc.productOptions.splice(0, 0, poc.productOptions.splice(poIndex, 1)[0]);
        }
        var newPoc = JSON.parse(JSON.stringify(poc));
        newPocs.push(newPoc);
      });
      return newPocs;
    }
  });
  module.exports = ConfigOptionsView;
});

